import { GenerateCustomTemplateRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateGenerateCustomTemplate = makeValidator({
  FieldParser: GenerateCustomTemplateRow,
});
